import {
  CiSearch,
  CiCircleInfo,
  CiPower,
  CiFilter,
  CiImport,
  CiCirclePlus,
  CiCircleMinus,
} from "react-icons/ci";
import {
  IoEyeOutline,
  IoEyeOffOutline,
  IoPowerOutline,
  IoHomeOutline,
  IoAddOutline,
} from "react-icons/io5";
import { PiCopySimpleThin, PiMedalLight } from "react-icons/pi";
import {
  IoIosClose,
  IoMdCheckmark,
  IoMdCheckmarkCircleOutline,
  IoIosArrowDropdown,
  IoIosArrowDown,
  IoIosArrowUp,
  IoMdCloseCircle,
  IoIosNotificationsOutline,
} from "react-icons/io";
import { FaUser } from "react-icons/fa";
import {
  FaChevronLeft,
  FaAngleRight,
  FaArrowRight,
  FaCircleCheck,
} from "react-icons/fa6";
import { GiCornerFlag, GiPartyPopper } from "react-icons/gi";
import { CiCalendar, CiSettings } from "react-icons/ci";
import {
  FiDollarSign,
  FiEdit2,
  FiUpload,
  FiKey,
  FiBriefcase,
  FiUsers,
  FiLink,
  FiCopy,
  FiMail,
} from "react-icons/fi";
import { RiDeleteBinLine, RiMedalLine } from "react-icons/ri";
import { LiaMedalSolid } from "react-icons/lia";
import { AiOutlineMore } from "react-icons/ai";
import { BsPersonFillX, BsPersonFillCheck } from "react-icons/bs";
import { BiCalendarCheck, BiMenu } from "react-icons/bi";
import { MdApartment } from "react-icons/md";
import TermDataIcon from "./TermDataIcon";
import EventsIcon from "./EventIcon";
import EmployeeIcon from "./EmployeeIcon";
import RewardsIcon from "./RewardsIcon";
import ReportsIcon from "./ReportsIcon";
import FAQManagementIcon from "./FAQManagementIcon";
import Reward from "./Reward";
import TeamIcon from "./TeamIcon";
import { TbTargetArrow } from "react-icons/tb";
import EventRequestIcon from "./EventRequestIcon";
import PreviousWinners from "./PreviousWinners";
import PrizesIcon from "./PrizesIcon";
import TeamMembersIcon from "./TeamMembersIcon";
import ParticipantsIcon from "./ParticipantsIcon";
import ChallengesIcon from "./ChallengesIcon";
import NotificationsIcon from "./NotificationsIcon";
import ActivityIcon from "./ActivityIcon";

export let reactIcons = {
  dropdownDownArrow: IoIosArrowDropdown as React.FC<
    React.SVGProps<SVGSVGElement>
  >,
  badgeIcon: RiMedalLine as React.FC<React.SVGProps<SVGSVGElement>>,
  achievementBadge: LiaMedalSolid as React.FC<React.SVGProps<SVGSVGElement>>,
  checkMarkIcon: IoMdCheckmark as React.FC<React.SVGProps<SVGSVGElement>>,
  leftIcon: FaChevronLeft as React.FC<React.SVGProps<SVGSVGElement>>,
  rightIcon: FaAngleRight as React.FC<React.SVGProps<SVGSVGElement>>,
  closeIcon: IoIosClose as React.FC<React.SVGProps<SVGSVGElement>>,
  ciPowerIcon: CiPower as React.FC<React.SVGProps<SVGSVGElement>>,
  copyIcon: PiCopySimpleThin as React.FC<React.SVGProps<SVGSVGElement>>,
  infoIcon: CiCircleInfo as React.FC<React.SVGProps<SVGSVGElement>>,
  searchIcon: CiSearch as React.FC<React.SVGProps<SVGSVGElement>>,
  visibilityOffIcon: IoEyeOffOutline as React.FC<React.SVGProps<SVGSVGElement>>,
  visibilityOnIcon: IoEyeOutline as React.FC<React.SVGProps<SVGSVGElement>>,
  FilterIcon: CiFilter as React.FC<React.SVGProps<SVGSVGElement>>,
  Flag: GiCornerFlag as React.FC<React.SVGProps<SVGSVGElement>>,
  calender: CiCalendar as React.FC<React.SVGProps<SVGSVGElement>>,
  dollar: FiDollarSign as React.FC<React.SVGProps<SVGSVGElement>>,
  edit: FiEdit2 as React.FC<React.SVGProps<SVGSVGElement>>,
  key: FiKey as React.FC<React.SVGProps<SVGSVGElement>>,
  checkMarkCircle: IoMdCheckmarkCircleOutline as React.FC<
    React.SVGProps<SVGSVGElement>
  >,
  delete: RiDeleteBinLine as React.FC<React.SVGProps<SVGSVGElement>>,
  upload: FiUpload as React.FC<React.SVGProps<SVGSVGElement>>,
  more: AiOutlineMore as React.FC<React.SVGProps<SVGSVGElement>>,
  Person: FaUser as React.FC<React.SVGProps<SVGSVGElement>>,
  inActivatePerson: BsPersonFillX as React.FC<React.SVGProps<SVGSVGElement>>,
  activatePerson: BsPersonFillCheck as React.FC<React.SVGProps<SVGSVGElement>>,
  export: CiImport as React.FC<React.SVGProps<SVGSVGElement>>,
  calendarCheck: BiCalendarCheck as React.FC<React.SVGProps<SVGSVGElement>>,
  terDataCalendrCheck: TermDataIcon as React.FC<React.SVGProps<SVGSVGElement>>,
  eventIcon: EventsIcon as React.FC<React.SVGProps<SVGSVGElement>>,
  employeeIcon: EmployeeIcon as React.FC<React.SVGProps<SVGSVGElement>>,
  student: FiUsers as React.FC<React.SVGProps<SVGSVGElement>>,
  rewardsIcon: RewardsIcon as React.FC<React.SVGProps<SVGSVGElement>>,
  reportsicon: ReportsIcon as React.FC<React.SVGProps<SVGSVGElement>>,
  faqManagementIcon: FAQManagementIcon as React.FC<
    React.SVGProps<SVGSVGElement>
  >,
  department: FiBriefcase as React.FC<React.SVGProps<SVGSVGElement>>,
  accordianOpen: CiCirclePlus as React.FC<React.SVGProps<SVGSVGElement>>,
  accordianClose: CiCircleMinus as React.FC<React.SVGProps<SVGSVGElement>>,
  rightArrow: FaArrowRight as React.FC<React.SVGProps<SVGSVGElement>>,
  medal: PiMedalLight as React.FC<React.SVGProps<SVGSVGElement>>,
  menu: BiMenu as React.FC<React.SVGProps<SVGSVGElement>>,
  arrowDown: IoIosArrowDown as React.FC<React.SVGProps<SVGSVGElement>>,
  arrowUp: IoIosArrowUp as React.FC<React.SVGProps<SVGSVGElement>>,
  logout: IoPowerOutline as React.FC<React.SVGProps<SVGSVGElement>>,
  home: IoHomeOutline as React.FC<React.SVGProps<SVGSVGElement>>,
  rewardIcon: Reward as React.FC<React.SVGProps<SVGSVGElement>>,
  teamIcon: TeamIcon as React.FC<React.SVGProps<SVGSVGElement>>,
  eventRequest: EventRequestIcon as React.FC<React.SVGProps<SVGSVGElement>>,
  previuosWinners: PreviousWinners as React.FC<React.SVGProps<SVGSVGElement>>,
  prizes: PrizesIcon as React.FC<React.SVGProps<SVGSVGElement>>,
  teamMenbers: TeamMembersIcon as React.FC<React.SVGProps<SVGSVGElement>>,
  masterIcon: CiSettings as React.FC<React.SVGProps<SVGSVGElement>>,
  targetArrow: TbTargetArrow as React.FC<React.SVGProps<SVGSVGElement>>,
  link: FiLink as React.FC<React.SVGProps<SVGSVGElement>>,
  checkCircleIcon: FaCircleCheck as React.FC<React.SVGProps<SVGSVGElement>>,
  unCheckCircleIcon: IoMdCloseCircle as React.FC<React.SVGProps<SVGSVGElement>>,
  add: IoAddOutline as React.FC<React.SVGProps<SVGSVGElement>>,
  notification: IoIosNotificationsOutline as React.FC<
    React.SVGProps<SVGSVGElement>
  >,
  copy: FiCopy as React.FC<React.SVGProps<SVGSVGElement>>,
  mail: FiMail as React.FC<React.SVGProps<SVGSVGElement>>,
  participantsIcon: ParticipantsIcon as React.FC<React.SVGProps<SVGSVGElement>>,
  challengesIcon: ChallengesIcon as React.FC<React.SVGProps<SVGSVGElement>>,
  notificationsIcon: NotificationsIcon as React.FC<
    React.SVGProps<SVGSVGElement>
  >,
  activityIcon: ActivityIcon as React.FC<React.SVGProps<SVGSVGElement>>,
};
